import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  buttons: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}))

export default styles
